<div class="publish theme-light" [ngSwitch]="mode">
    
    <div class="publish__options text-12">

      <!-- mode selection -->
      <app-widget
        [formGroup]="formModeGroup"
        label="Select a format to publish:"
        [isCompact]="true"
        [canToggle]="false">
        <div class="publish__flex-group">
          <mat-radio-group formControlName="mode">
            <mat-radio-button value="3d" class="mr-2">3D Embeddable</mat-radio-button>
            <mat-radio-button value="2d">Image</mat-radio-button>
          </mat-radio-group>
        </div>
      </app-widget>

      <!-- 3D mode-->
      <ng-container *ngSwitchCase="'3d'" [formGroup]="form">
        <!-- dimensions -->
        <app-widget 
          formGroupName="dimensions"
          *ngIf="dimensions$ | async as dimensions"
          label="Size"
          [isCompact]="true"
          [canToggle]="false">

          <div class="publish__flex-group" *ngIf="minDimensions$ | async as minDimensions">

              <app-form-field [isCompact]="true" label="Width" theme="light" display="inline" class="mr-6">
                <input type="number" class="publish__input input input--small" formControlName="width">
                <div class="mt-1" form-field-help>Min. {{ minDimensions.width }}px</div>
              </app-form-field>
        
              <app-form-field [isCompact]="true" label="Height" theme="light" display="inline">
                <input type="number" class="publish__input input input--small" formControlName="height">
                <div class="mt-1" form-field-help>Min. {{ minDimensions.height }}px</div>
              </app-form-field>

          </div>

        </app-widget>
          
        <!-- display options -->
        <app-widget
          formGroupName="options"
          label="Display Options"
          [isCompact]="true"
          [canToggle]="false" 
          [open]="true">
          <div class="publish__group">
            <mat-checkbox formControlName="uiZoom">Zoom In/Zoom Out</mat-checkbox>
            <mat-checkbox formControlName="uiCameraMode">Pan</mat-checkbox>
            <mat-checkbox formControlName="uiCenter">Center</mat-checkbox>
            <mat-checkbox formControlName="uiShare">Share</mat-checkbox>
            <mat-checkbox formControlName="uiInfo">Info</mat-checkbox>
            <mat-checkbox formControlName="uiFullscreen">Full Screen</mat-checkbox>
            <mat-checkbox formControlName="uiHelp">Help</mat-checkbox>
            <mat-checkbox formControlName="uiObjectTree">Anatomy Tree</mat-checkbox>    
          </div>
        </app-widget>

        <!-- edit options -->
        <app-widget
          formGroupName="options"
          label="Edit Tools"
          [isCompact]="true"
          [canToggle]="false"
          [open]="true">

          <div class="publish__group">
            <mat-checkbox formControlName="uiDissect">Dissect</mat-checkbox>
            <mat-checkbox formControlName="uiIsolate">Isolate</mat-checkbox>
            <mat-checkbox formControlName="uiXray">X-ray</mat-checkbox>
            <mat-checkbox formControlName="uiAnnotations">Annotations</mat-checkbox>
            <div class="mt-2">
                <button
                  *ngIf="!uiToolsGrouped"
                  app-button buttonType="outline"
                  buttonTheme="light"
                  buttonSize="xsmall"
                  (click)="setUIToolsGrouped(true)"
                  style="width: 130px;">
                  Group In Toolbar
                </button>
                <button
                  *ngIf="uiToolsGrouped"
                  app-button buttonType="outline"
                  buttonTheme="light"
                  buttonSize="xsmall"
                  (click)="setUIToolsGrouped(false)"
                  style="width: 130px;">
                  Ungroup 
                </button>
              </div>
          </div>

        </app-widget>

        <!-- loading options -->
        <app-widget
          label="Loading Experience"
          [isCompact]="true"
          [canToggle]="false"
          [open]="true">

          <div formGroupName="rotate" class="mb-1">
            <mat-checkbox formControlName="enabled">Rotate 3D Model</mat-checkbox>
            
            <app-form-field *ngIf="rotateEnabled" label="Degrees" theme="light" [isCompact]="true">
              <input type="number" class="publish__input input" formControlName="value">
            </app-form-field>
          </div>

          <div formGroupName="initial" class="mb-2">
            <mat-checkbox formControlName="enabled">Show "Click to Interact" hint</mat-checkbox>
            <div class="m-1 ml-5">
              <mat-radio-group formControlName="mode">
                <mat-radio-button value="button" class="mr-4">Button</mat-radio-button>
                <mat-radio-button value="handHint">Animated hand</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <div formGroupName="disableScroll">
            <mat-checkbox formControlName="enabled">Disable scroll wheel zooming</mat-checkbox>
            <div class="m-1 ml-5">
              <mat-radio-group formControlName="mode">
                <mat-radio-button value="alert" class="mr-4">Show alert</mat-radio-button>
                <mat-radio-button value="overlay">Show overlay</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </app-widget>

      </ng-container>

      <!-- 2D mode -->
      <ng-container
        *ngSwitchCase="'2d'"
        [formGroup]="formSnapshot">
  
          <!-- image size -->
          <app-widget
            label="Size"
            [isCompact]="true"
            [canToggle]="false">
  
            <button
              app-button
              buttonType="outline"
              buttonTheme="light"
              [uppercase]="false"
              [matMenuTriggerFor]="imageSizes">
              {{ formatScreenSizeText(selectedSnapshotSize) }} <fa-icon icon="caret-down" class="ml-1"></fa-icon>
            </button>
  
            <mat-menu #imageSizes="matMenu">
              <button
                mat-menu-item
                *ngFor="let snapSize of snapshotSizes"
                (click)="handleSnapshotSizeClick(snapSize)">
                  {{ formatScreenSizeText(snapSize) }}
              </button>
            </mat-menu>
  
            <div class="publish__flex-group mt-2" formGroupName="dimensions">

              <app-form-field [isCompact]="true" label="Width" theme="light" display="inline" class="mr-6">
                <input type="number" class="publish__input input input--small" formControlName="width" [min]="minSnapshotDimensions.width" [max]="maxSnapshotDimensions.width">
                <div class="mt-1" form-field-help>{{ minSnapshotDimensions.width }}px to {{ maxSnapshotDimensions.width }}px</div>
              </app-form-field>
        
              <app-form-field [isCompact]="true" label="Height" theme="light" display="inline">
                <input type="number" class="publish__input input input--small" formControlName="height" [min]="minSnapshotDimensions.height" [max]="maxSnapshotDimensions.height">
                <div class="mt-1" form-field-help>{{ minSnapshotDimensions.height }}px to {{ maxSnapshotDimensions.height }}px</div>
              </app-form-field>

            </div>
  
          </app-widget>
          
          <!-- color selection -->
          <app-widget
            label="Background Color"
            [isCompact]="true"
            [canToggle]="false">
            <div class="publish__flex-group">
              <app-color-picker
                size="normal"
                alphaEnabled="false"
                [color]="snapshotBGColor"
                (colorSelected)="handleSnapshotBGColorClick($event)"
                class="publish__picker">
              </app-color-picker>
            
              <button app-button buttonType="outline" buttonTheme="light" buttonSize="xsmall" (click)="handleSnapshotBGColorClick(null)">Reset Color</button>
            </div>
          </app-widget>

          <div class="mt-4">
            <a href="https://www.biodigital.com/terms" target="_blank" class="text-link">Read about our Terms of Use</a>
          </div>

      </ng-container>

    </div>

    <!-- actions -->
    <div class="publish__actions">

      <!-- 3D options -->
      <ng-container *ngSwitchCase="'3d'">
        <div class="text-12 p-2 mt-2 mb-2">
            Make this model available to anyone by publishing it to the web.
        </div>

        <div class="publish__actions-content">
          <button class="mb-2 w-100" app-button buttonType="flat" buttonTheme="light" (click)="handleGenerateIFrame()" [disabled]="!this.form.valid">Copy embed</button>
          <button class="w-100" app-button buttonType="flat" buttonTheme="light" (click)="handleGenerateURL()" [disabled]="!this.form.valid">Copy URL</button>
        </div>
      </ng-container>

      <!-- 2D options -->
      <ng-container *ngSwitchCase="'2d'">
          <div class="text-12 p-2 mt-2 mb-2">
              Download this image or make it available to anyone by publishing it to the web.
          </div>
  
          <div class="publish__actions-content">
            <button class="mb-2 w-100" app-button buttonType="flat" buttonTheme="light" (click)="handleDownloadSnapClick()" [disabled]="!this.formSnapshot.valid">Download</button>
            <button class="mb-2 w-100" app-button buttonType="flat" buttonTheme="light" (click)="handleCopyImageURL()" [disabled]="!this.formSnapshot.valid">Copy URL</button>
            <button class="w-100" app-button buttonType="flat" buttonTheme="light" (click)="handleGenerateImage()" [disabled]="!this.formSnapshot.valid">Copy Embed</button>
          </div>
      </ng-container>
      
    </div>

    <!-- widget -->
    <app-publish-widget
      #publishWidget
      class="publish__embed"
      [model]="model"
      [widgetParams]="widgetOptions"
      [width]="widgetWidth"
      [height]="widgetHeight"
      [bgColor]="widgetBGColor"
      [scalable]="widgetScalable"
      (cameraUpdated)="handleCameraUpdated($event)">
    </app-publish-widget>

</div>